import owd from '../owd/owd';

export default class CursorHover extends owd.Component {
	init() {
		this.app.getModule('customHover').addModifier(this.$element[0]);
	}

    destroy() {
        super.destroy();
        this.app.getModule('customHover').removeModifier(this.$element[0]);
    }
}

owd.registerComponent('cursor-hover', {
	component: CursorHover
});
